import * as THREE from 'three';
import { InteractiveStar } from './InteractiveStar.js';

const SKY_RADIUS = 800;

function azAlt(azDeg, altDeg) {
  const az = (azDeg * Math.PI) / 180;
  const alt = (altDeg * Math.PI) / 180;
  const cosAlt = Math.cos(alt);
  return new THREE.Vector3(
    SKY_RADIUS * cosAlt * Math.sin(az),
    SKY_RADIUS * Math.sin(alt),
    -SKY_RADIUS * cosAlt * Math.cos(az),
  );
}

const SNOWBOARDING_CARD = `
  <h2>Snowboarding</h2>
  <div class="label">A new joy</div>

  <p>You picked up snowboarding recently. You are getting better at it every time you go.</p>

  <p>You were not trying to master it. You just wanted to do something fast on snow because you felt like it.</p>

  <hr>

  <p>This star is the part of your sky that says: I am still trying things. I am still beginning. I am still picking up speed.</p>

  <p>That is also a kind of light.</p>
`;

/**
 * Snowboarding - a stationary interactive star with a cool icy blue-white
 * glow. Sits in the upper north sky near Europa (both are "cold" things,
 * thematically clustered).
 *
 * The visual deviation from gold (the default discoverable color) is
 * thematic: snowboarding is ice and snow, the same way the Birth Star is
 * sun-yellow because it's a real Sun. Each color choice is deliberate.
 */
export function createSnowboarding({ onClick }) {
  return new InteractiveStar({
    position: azAlt(340, 65),
    color: 0xc8e8ff,
    glowColor: '200, 232, 255',
    scale: 28,
    pulseSpeed: 0.8,
    pulseAmount: 0.04,
    discoveryId: 'snowboarding',
    category: 'hobbies',
    cardHTML: SNOWBOARDING_CARD,
    onClick,
  });
}
